export const profile = {
  name: 'Ujwal Magar',
  shortName: 'Ujwal',
  role: 'Full-Stack Engineer',
  tagline: 'Seller Inbox AI is live. Velora is in development.',
  headline: 'I shipped an AI reply tool for Nepali sellers.\nVelora is next.',
  summary:
    'Seller Inbox AI lets sellers generate replies grounded in their own product catalog, not generic AI guesses. Velora is an AI-guided IELTS/PTE practice platform for Nepal combined with an optional mentor booking marketplace — featuring an AI feedback loop, booking state machine, manual pilot payments, and a React admin panel. The backend a real learning platform actually needs.',
  email: 'magarujwal16@gmail.com',
  location: 'Nepal',
  links: {
    github: 'https://github.com/ujwalmagar',
    linkedin: 'https://www.linkedin.com/in/ujwalmagar/',
    sellerInboxLive: 'https://sellers-inbox-ai.vercel.app/',
    sellerInboxGithub: 'https://github.com/ujwalmagar/sellers-inbox-AI',
  },
};

export const techGroups = [
  {
    title: 'Frontend',
    items: ['React', 'Vite', 'TypeScript', 'Tailwind CSS'],
  },
  {
    title: 'Backend',
    items: ['Node.js', 'Express', 'REST APIs', 'Cookie Auth / CSRF', 'JWT Auth'],
  },
  {
    title: 'Database',
    items: ['PostgreSQL', 'Prisma', 'Raw SQL'],
  },
  {
    title: 'Mobile',
    items: ['Flutter', 'Dart', 'Dio', 'GoRouter', 'FlutterSecureStorage', 'Bloc/Cubit'],
  },
  {
    title: 'Payments & Jobs',
    items: ['Stripe', 'Webhooks', 'Redis', 'BullMQ'],
  },
  {
    title: 'Storage & Cloud',
    items: ['Cloudinary', 'Vercel'],
  },
  {
    title: 'Tooling & AI',
    items: ['Groq AI', 'Postman', 'GitHub'],
  },
];
